export const CURATION_FEATURE_NAME = 'curation';
